import React from "react";
import "./App.css";
import logo from "../../logo.png";

function App() {
  return (
    <div className="App">
      {/* Header Section */}
      <header className="hero-section">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="content-container">
          <h1>Shop Smarter, Spend Better.</h1>
          <p>
            Take a moment to pause and think before making impulse purchases.
            Our Chrome extension helps you make rational shopping decisions and
            save money every month.
          </p>
          <button
            className="cta-button"
            onClick={() =>
              window.open("https://chrome.google.com/webstore", "_blank")
            }
          >
            Add to Chrome – Only $2.99/month
          </button>
        </div>
      </header>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <h2>Why You Need 'Think Before You Buy' Chrome Extension</h2>
        <p>
          Impulse shopping can hurt your wallet without you even realizing it.
          With online shopping becoming so convenient, it's easy to spend
          hundreds of dollars on things you don’t need.
        </p>
        <ul>
          <li>
            <strong>Pause at the Right Time:</strong> Before every checkout, our
            extension gently reminds you to reconsider your cart items.
          </li>
          <li>
            <strong>Rethink Your Needs:</strong> Avoid buyer's remorse by taking
            a step back and asking, "Do I really need this?"
          </li>
          <li>
            <strong>Save Money Instantly:</strong> Reduce unnecessary spending
            and keep more money in your account.
          </li>
        </ul>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <h2>See What People Are Saying</h2>
        <div className="testimonial">
          <p>
            "This extension stopped me from spending $200 on things I didn’t
            even need last month!"
          </p>
          <p>
            <strong>– Sarah L.</strong>
          </p>
        </div>
        <div className="testimonial">
          <p>
            "It’s like a personal shopping assistant that keeps me on track.
            Definitely worth $2.99/month."
          </p>
          <p>
            <strong>– Jessica R.</strong>
          </p>
        </div>
        <div className="testimonial">
          <p>
            "Pause and Think helped me break the impulse shopping habit. Highly
            recommend!"
          </p>
          <p>
            <strong>– Nisan M.</strong>
          </p>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing">
        <h2>Affordable and Effective</h2>
        <p>
          For just <strong>$2.99/month</strong>, you get access to a powerful
          tool that helps you shop rationally and save hundreds of dollars every
          year. Think of it as an investment in your financial future.
        </p>
        <button
          className="cta-button"
          onClick={() =>
            window.open("https://chrome.google.com/webstore", "_blank")
          }
        >
          Start Saving Now – Add to Chrome
        </button>
      </section>

      {/* Contact Section */}
      <section className="contact">
        <h2>Get in Touch</h2>
        <p>Have questions? We’d love to hear from you!</p>
        <ul style={{ display: "flex", flexDirection: "column" }}>
          <li>
            <strong>Email:</strong> adamsnb34@gmail.com
          </li>
          <li>
            <strong>Yokohama-shi, Japan</strong>
          </li>
        </ul>
      </section>

      {/* Business Information Table */}
      <section className="business-info">
        <h2>Business Profile</h2>
        <table className="info-table">
          <thead>
            <tr>
              <th>Item</th>
              {/* <th>Explanation</th> */}
              <th>Example</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Name of Distributor</td>
              {/* <td>Business name or sole proprietor's name.</td> */}
              <td>Nishan Baral (sole proprietor)</td>
            </tr>
            <tr>
              <td>Location</td>
              {/* <td>Business address (can be disclosed upon request).</td> */}
              <td>
                240-0003 <br />
                1-20-12 Kanagawa-ken, Yokohama-shi, Japan
              </td>
            </tr>
            <tr>
              <td>Telephone Number</td>
              {/* <td>For customer inquiries (can disclose upon request).</td> */}
              <td>(+81) 080-3013-4706</td>
            </tr>
            <tr>
              <td>Email Address</td>
              {/* <td>Email for customer support inquiries.</td> */}
              <td>adamsnb34@gmail.com</td>
            </tr>
            <tr>
              <td>Operations Manager</td>
              {/* <td>Representative of the business or organization.</td> */}
              <td>Nishan Baral</td>
            </tr>
            <tr>
              <td>Additional Fees</td>
              {/* <td>Details of any additional charges.</td> */}
              <td>No additional and hidden fees </td>
            </tr>
            <tr>
              <td>Exchanges & Returns</td>
              {/* <td>Policy for returns, exchanges, and refunds.</td> */}
              <td>
                Subscription cancellation can be done through extension itself
              </td>
            </tr>
            {/* <tr>
              <td>Delivery Time</td>
              <td>Expected delivery time for orders.</td>
              <td>It's a installable chrome extension, delivery time is the time </td>
            </tr> */}
            <tr>
              <td>Payment Methods</td>
              {/* <td>Accepted payment methods.</td> */}
              <td>Credit card or Debit card processed via Stripe</td>
            </tr>
            <tr>
              <td>Settlement Period</td>
              {/* <td>Time frame for payment.</td> */}
              <td>
                Credit card: Immediate.
                <br />
              </td>
            </tr>
            <tr>
              <td>Sales Price</td>
              {/* <td>Price of goods/services including tax.</td> */}
              <td>$2.99 per month (approx ¥450 as in Dec 10, 2024)</td>
            </tr>
            <tr>
              <td>Software operating environment</td>
              {/* <td>Price of goods/services including tax.</td> */}
              <td>Requires Google Chrome browser for installation </td>
            </tr>
          </tbody>
        </table>
        <small
          style={{
            fontSize: 8,
            color: "grey",
            minWidth: "100%",
            marginBottom: "10px",
          }}
        >
          Our business information follows Japanese government "Notation based
          on the Specified Commercial Transactions Act" for consumer interests
          protection
        </small>
      </section>

      {/* Footer */}
      <footer>
        <p>© 2024 ThinkBeforeYouBuy – Shop Smarter, Spend Better.</p>
      </footer>
    </div>
  );
}

export default App;
